<template>
  <div class="personalIndex xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="4"></hd-img>
        </div>
        <div class="personal-right">
          <div class="content">
            <div class="flex-start">
              <div class="line-title"></div>
              <div class="pageTitle">提现管理</div>
            </div>
            <div class="flex-center">
              <div class="part-box">
                <!-- <div class="part1 flex-space-between" v-if="this.Services.ClientId == 'MedicineDiagnosis.Web'"> -->
                <div class="part1 flex-space-between"  v-if="this.Services.ClientId == 'MedicineDiagnosis.Web'">
                  <div class="flex-center-columns">
                      <img class="img1" src="../../assets/img/interrogation/xiaoimg.png" style="margin-right: 5px; width: 200px" />
                      <div class="desc flex-center-columns">
                        <p>手机微信扫码打开</p>
                        <p>千越医助手小程序</p>
                      </div>
                  </div>
                  <div class="flex-center-columns">
                    <img class="img1" src="../../assets/img/interrogation/APPimg.png" style="width: 200px" />
                    <div class="desc flex-center-columns">
                      <p>手机浏览器扫码下载</p>
                      <p>千越医助手APP</p>
                    </div>
                  </div>
                </div>
                <div class="part1 flex-space-between"  v-if="this.Services.ClientId == 'CloudWeb'">
                  <div class="flex-center-columns">
                      <img class="img1" src="../../assets/img/interrogation/renyiImg.jpg" style="margin-right: 5px; width: 200px" />
                      <div class="desc flex-center-columns">
                        <p>手机微信扫码打开</p>
                        <p>千越仁医小程序</p>
                      </div>
                  </div>
                  <div class="flex-center-columns">
                    <img class="img1" src="../../assets/img/interrogation/renyiApp.png" style="width: 200px" />
                    <div class="desc flex-center-columns">
                      <p>手机浏览器扫码下载</p>
                      <p>千越仁医APP</p>
                    </div>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="tip">提现管理：电脑端暂不支持敏感操作，请通过官方APP或小程序完成提现</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
export default {
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    return {
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "../../assets/css/footer.css";
.personal-content {
  background: #f2f2f2;
  padding: 40px 0;
}
.personal-box {
  width: 1200px;
  margin: 0 auto;
}
.personal-left {
  float: left;
}
.personal-right {
  float: right;
  width: 985px;
}

.pointer {
  cursor: pointer;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.part-box {
  // width: 50%;
  margin-top: 10%;
  .desc {
    margin-top: 10px;
  }
  .img1 {
    // border: 1px dashed #999;
  }
  .tip {
    width: 100%;
    color: #00a391;
    text-align: center;
  }
}
</style>
